import {
  calculateCareerStatistics,
  projectTournamentHistory,
  projectAchievements,
  inferFavoriteEvents,
} from "../../../domain/player/playerCareer";
import { projectTennisSportAchievements } from "../../../domain/player/playerAchievementFramework";
import { projectTennisMatchIntelligence } from "../../../domain/matchHistory/buildMatchIntelligence";

/**
 * Tennis statistics — career primitives + set/game counts from cards when present.
 */
export function createTennisStatisticsProvider() {
  return {
    calculateCareerStatistics(cards) {
      const base = calculateCareerStatistics(cards);
      let setsWon = 0;
      let setsLost = 0;
      (cards || []).forEach((c) => {
        if (c.setsWon != null) setsWon += Number(c.setsWon) || 0;
        if (c.setsLost != null) setsLost += Number(c.setsLost) || 0;
      });
      return {
        ...base,
        setsWon,
        setsLost,
      };
    },
    projectTournamentHistory,
    projectAchievements,
    inferFavoriteEvents,
    projectSportAchievements: projectTennisSportAchievements,
    projectMatchIntelligence: projectTennisMatchIntelligence,
  };
}
